export const ORDER_MANAGEMENT_RIGHT_MENU = {
    SET_INITIAL_DATE:'ORDER_MANAGEMENT_RIGHT_MENU.SET_INITIAL_DATE',
    SET_FINAL_DATE:'ORDER_MANAGEMENT_RIGHT_MENU.SET_FINAL_DATE',
    SET_STATE_SITUATIONS:'ORDER_MANAGEMENT_RIGHT_MENU.SET_STATE_SITUATIONS',
    SET_STATE_LIST_MENU_SELECTIONS:'ORDER_MANAGEMENT_RIGHT_MENU.SET_STATE_LIST_MENU_SELECTIONS',
    SET_FILTERS_APPLIED_ORDER_MANAGEMENT: 'ORDER_MANAGEMENT_RIGHT_MENU.SET_FILTERS_APPLIED_ORDER_MANAGEMENT', 
    SET_LIST_STATE_ORIGIN:'ORDER_MANAGEMENT_RIGHT_MENU.SET_LIST_STATE_ORIGIN'
}